
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Contact Form</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Contact Form</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="CMSContactForm">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CMSContactFormList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Form Body</label>
              <textarea id="form_body" name="form_body"
                 v-bind:class="{'has-error' : errors.has('form_body')}"
                 v-validate="'required'"
                 v-model="value.form_body" class="form-control form_body"
                 placeholder="Form Body"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('form_body')">
                {{ errors.first("form_body") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Mail To</label>
              <input type="text" id="mail_to" name="mail_to"
                     v-bind:class="{'has-error' : errors.has('mail_to')}"
                     v-validate="'required'"
                     v-model="value.mail_to" class="form-control mail_to"
                     placeholder="Mail To">
              <div class="help text-danger" v-show="errors.has('mail_to')">
                {{ errors.first("mail_to") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Subject</label>
              <input type="text" id="subject" name="subject"
                     v-bind:class="{'has-error' : errors.has('subject')}"
                     v-validate="'required'"
                     v-model="value.subject" class="form-control subject"
                     placeholder="Subject">
              <div class="help text-danger" v-show="errors.has('subject')">
                {{ errors.first("subject") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Mail Body</label>
              <textarea id="mail_body" name="mail_body"
                 
                 
                 v-model="value.mail_body" class="form-control mail_body"
                 placeholder="Mail Body"
                 rows="3"></textarea>
              
            </div>
            <div class="form-group " >
              <label class="control-label">Success Message</label>
              <input type="text" id="success_message" name="success_message"
                     
                     
                     v-model="value.success_message" class="form-control success_message"
                     placeholder="Success Message">
              
            </div>
            <div class="form-group " >
              <label class="control-label">Failed Message</label>
              <input type="text" id="failed_message" name="failed_message"
                     
                     
                     v-model="value.failed_message" class="form-control failed_message"
                     placeholder="Failed Message">
              
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSContactFormForm",
  metaInfo: {
    title: "CMS Contact Form | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      
    }
  }),
  methods: {
    
    
    
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_contact_forms";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_contact_forms/" + _this.$route.params.id
            method = "PUT";
          }

          

          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CMSContactFormList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_contact_forms/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        
        
      }
      
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

        